var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _circle, _circle2, _path13, _path14, _path15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentSearchIconSirarNavigation2X(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 153,
    viewBox: "0 0 139 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.5 28.5L77 4L77.5 28.5H101.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101.5 28.5V119.5H4.5V4H77M101.5 28.5L77 4M101.5 28.5H77.5L77 4",
    stroke: "white",
    strokeWidth: 8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M101.5 28.5L77 4L77.5 28.5H101.5Z",
    fill: "#1A2352"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 4V119.5H101.5V28.5H77.5L77 4H4.5Z",
    fill: "#1A2352"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M101.5 28.5V119.5H4.5V4H77M101.5 28.5L77 4M101.5 28.5H77.5L77 4",
    stroke: "white",
    strokeWidth: 8
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17 21.5H66",
    stroke: "white",
    strokeWidth: 6
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17 35H66",
    stroke: "white",
    strokeWidth: 6
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17 48H58",
    stroke: "white",
    strokeWidth: 6
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17 60.5H66",
    stroke: "white",
    strokeWidth: 6
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17 73.5H66",
    stroke: "white",
    strokeWidth: 6
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17 86.5H66",
    stroke: "white",
    strokeWidth: 6
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M17 99.5H66",
    stroke: "white",
    strokeWidth: 6
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 71.21,
    cy: 85.21,
    r: 29.97,
    fill: "#1A2352",
    stroke: "white",
    strokeWidth: 6.48
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 71.21,
    cy: 85.21,
    r: 36.735,
    stroke: "#1A2352",
    strokeWidth: 7.05
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M105.227 147.079C113.003 154.685 125.472 154.548 133.079 146.773C140.685 138.997 140.548 126.528 132.773 118.921L105.227 147.079ZM82.2274 124.579L105.227 147.079L132.773 118.921L109.773 96.4213L82.2274 124.579Z",
    fill: "#1A2352"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M113.478 138.359C116.438 141.409 121.31 141.482 124.359 138.522C127.409 135.562 127.482 130.69 124.522 127.641L113.478 138.359ZM86.7482 110.819L113.478 138.359L124.522 127.641L97.7918 100.101L86.7482 110.819Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.9236 106.328C57.6136 102.177 54.2003 95.7116 54.2003 88.4493C54.2003 75.9235 64.3545 65.7693 76.8803 65.7693C79.8048 65.7693 82.6001 66.3228 85.167 67.3309C81.3185 64.3223 76.4738 62.5293 71.2103 62.5293C58.6845 62.5293 48.5303 72.6835 48.5303 85.2093C48.5303 94.8106 54.4964 103.018 62.9236 106.328Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentSearchIconSirarNavigation2X);
export default __webpack_public_path__ + "static/media/Document Search Icon_SIRAR_Navigation@2x.13f63aa95668ec1aecd2a9754794eb56.svg";
export { ForwardRef as ReactComponent };